/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a colour harmony?`)
};

const es_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es una armonía de color?`)
};

const de_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist eine Farbharmonie?`)
};

const nl_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een kleurharmonie?`)
};

const fr_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'une harmonie de couleurs ?`)
};

const it_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è un'armonia di colori?`)
};

const pt_br2_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma harmonia de cores?`)
};

const pt_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma harmonia de cores?`)
};

const ja_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配色ルール(カラーハーモニー)とは何ですか?`)
};

const zh_cp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是配色方案（色彩和谐）？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq_q1", locale)
	if (locale === "en") return en_cp_faq_q1(inputs)
	if (locale === "es") return es_cp_faq_q1(inputs)
	if (locale === "de") return de_cp_faq_q1(inputs)
	if (locale === "nl") return nl_cp_faq_q1(inputs)
	if (locale === "fr") return fr_cp_faq_q1(inputs)
	if (locale === "it") return it_cp_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq_q1(inputs)
	if (locale === "pt") return pt_cp_faq_q1(inputs)
	if (locale === "ja") return ja_cp_faq_q1(inputs)
	return zh_cp_faq_q1(inputs)
};